import { EventType } from './gtm.enums';
import { IECommerceData } from './gtm.interfaces';

const base = (event: string, ecomm: Record<string, unknown>) => ({
  event: event,
  ecommerce: ecomm,
});

export const AddToCart = (data: IECommerceData) =>
  base(EventType.AddToCart, {
    add: data,
  });

export const RemoveFromCart = (data: IECommerceData) =>
  base(EventType.RemoveFromCart, {
    remove: data,
  });

export const Checkout = (data: IECommerceData) =>
  base(EventType.Checkout, {
    checkout: data,
  });

export const Purchase = (data: IECommerceData) =>
  base(EventType.Purchase, {
    purchase: data,
  });
